import { render } from "./IconQr.vue?vue&type=template&id=66bb083e"
import script from "./IconQr.vue?vue&type=script&lang=js"
export * from "./IconQr.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__